import axios from 'axios';
import { carregarNomesLogicos } from 'src/Areas/Genericos/GE/services/nomesLogicosService';

let nlConfigsCache: Record<string, any> | null = null;

export const runtimeConfigs = async () => {
  return axios
    .get('/static/config.json')
    .then(response => {
      return response.data;
    })
    .catch(() => {
      return null;
    });
};

export const runtimeNLConfigs = async () => {
  return axios
    .get('/static/config.json')
    .then(response => {
      const data = response.data || {};

      const nlConfigs: Record<string, any> = {};

      Object.keys(data).forEach(key => {
        if (key.startsWith('NL_')) {
          const newKey = key.substring(3);
          nlConfigs[newKey] = data[key];
        }
      });

      nlConfigsCache = nlConfigs;
      return nlConfigs;
    })
    .catch(() => {
      nlConfigsCache = {};
      return null;
    });
};

export const getNLConfig = (key: string) => {
  return nlConfigsCache?.[key];
};

export const setNLConfigs = (values: Record<string, any>) => {
  nlConfigsCache = {
    ...(nlConfigsCache || {}),
    ...values,
  };
};

export const getNLFromAPI = async (keys: string[]) => {
  const missingKeys = keys.filter(key => nlConfigsCache?.[key] === undefined);

  if (!missingKeys.length) {
    return nlConfigsCache;
  }

  try {
    const response = await carregarNomesLogicos(missingKeys);

    setNLConfigs(response.success ? response.data || {} : {});

    return nlConfigsCache;
  } catch {
    return nlConfigsCache;
  }
};

export const isNLConfigEnabled = (value: any) => {
  if (!value) {
    return true;
  }

  if (typeof value === 'boolean') {
    return value;
  }

  if (typeof value === 'string') {
    const nlValue = getNLConfig(value);

    if (!nlValue) {
      return false;
    }

    if (typeof nlValue === 'boolean') {
      return nlValue;
    }

    const normalized = nlValue.trim().toLowerCase();
    return normalized === 's' || normalized === 'sim';
  }

  return false;
};
